import { Switch } from '@flowus/common/components';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import React from 'react';

import { Option } from '../option';
import { SettingProvider } from '../common';
import { useModel } from 'src/common/create-model';

export const FormNotificationSetting: FC = () => {
  const { t } = useAppTranslation();
  const {
    spaceSettingState: { disableFormNotification, setDisableFormNotification },
  } = useModel(SettingProvider);
  return (
    <Option
      title={t('components.space_setting.form_notification.title')}
      description={t('components.space_setting.form_notification.description')}
      rightPart={
        <Switch
          open={!disableFormNotification}
          onSwitch={(status) => {
            setDisableFormNotification(!status);
          }}
        />
      }
    />
  );
};
